module.exports = __webpack_public_path__ + "img/yt.85556bea.svg";